import {
  cellSelectionFeature,
  columnOrderingFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  createSortedRowModel,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
  sortFn_alphanumeric,
  sortFn_datetime,
  sortFn_text,
  sortFn_textCaseSensitive,
  tableFeatures,
  type CellData,
  type ColumnDef,
  type RowData,
} from "@tanstack/react-table";

const dataTableFeatures = tableFeatures({
  cellSelectionFeature,
  columnOrderingFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
  sortedRowModel: createSortedRowModel(),
  sortFns: {
    alphanumeric: sortFn_alphanumeric,
    datetime: sortFn_datetime,
    text: sortFn_text,
    textCaseSensitive: sortFn_textCaseSensitive,
  },
});

type DataTableFeatures = typeof dataTableFeatures;

type DataTableColumnDef<
  TData extends RowData,
  TValue extends CellData = CellData,
> = ColumnDef<DataTableFeatures, TData, TValue>;

export { dataTableFeatures };
export type { DataTableColumnDef, DataTableFeatures };
